import { render, staticRenderFns } from "./CompanyMessage.vue?vue&type=template&id=a9ba3fe0&scoped=true"
import script from "./CompanyMessage.vue?vue&type=script&lang=js"
export * from "./CompanyMessage.vue?vue&type=script&lang=js"
import style0 from "./CompanyMessage.vue?vue&type=style&index=0&id=a9ba3fe0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ba3fe0",
  null
  
)

export default component.exports